import { createFileRoute, redirect } from "@tanstack/react-router"
import { useAuthStore } from "@/store/auth.store"

export const Route = createFileRoute("/profile")({
  validateSearch: (search: Record<string, unknown>): { tab?: string; edit?: string | boolean } => ({
    tab: (search.tab as string) || undefined,
    edit: (search.edit as string | boolean) || undefined,
  }),
  beforeLoad: ({ search }) => {
    const { isAuthenticated, user } = useAuthStore.getState()
    if (!isAuthenticated) throw redirect({ to: "/login" })
    const role = user?.role?.toUpperCase()
    if (role === "BUYER") {
      throw redirect({
        to: "/dashboard/profile",
        search,
      })
    }
  },
})
